// import { Component, OnInit } from '@angular/core';
import * as _ from 'lodash';
import { FormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ENTER, COMMA } from '@angular/cdk/keycodes';
import { UserProfile } from 'src/app/core/models/user';
import { HttpErrorResponse } from '@angular/common/http';
import { ActivatedRoute, Router, RouteReuseStrategy } from '@angular/router';
import { MatChipInputEvent } from '@angular/material/chips';
import { GDPRService } from 'src/app/core/services/rulebook';
import { Logger, MasterHelper } from 'src/app/core/utilities';
import { ToastViewModel } from 'src/app/core/models/view-model';
import { Role } from 'src/app/core/models/user-management/role';
import { RulebookViewModel } from 'src/app/core/models/rulebook';
import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import { ItemInfoDto } from '../../../core/models/rulebook/item.info-dto';
import { SessionService } from 'src/app/core/services/auth/session.service';
import { RulebookModel } from 'src/app/core/models/rulebook/rulebook.model';
import { CommonService } from './../../../core/services/common/common.service';
import { Component, OnInit, ViewChild, Input, ElementRef, HostListener, Renderer2, ChangeDetectorRef } from '@angular/core';
import { DateRangeModel } from './../../../core/models/rulebook/date-range-model';
import { ItemActiveModel } from 'src/app/core/models/view-model/item-acive-model';
import { BulkRulebookData } from 'src/app/core/models/rulebook/bulk-rulebook-data';
import { AlertDialogModel } from '../../../core/models/view-model/alert-dialog.model';
import { RulebookDialogComponent } from '../rulebook-dialog/rulebook-dialog.component';
import { RulebookColumnModel } from 'src/app/core/models/view-model/rulebook-column-model';
import { RulebookFilterModel } from './../../../core/models/rulebook/rulebook-filters-model';
import { MatAutocomplete, MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { BulkRuleAnalyticComponent } from '../bulk-rule-analytic/bulk-rule-analytic.component';
import { ModalDialogComponent } from '../../distributed-ui-components/modal-dialog/modal-dialog.component';
import { DeleteDialogComponent } from '../../distributed-ui-components/delete-dialog/delete-dialog.component';
import { LazyLoadEvent } from 'primeng/api';
//import { Table } from 'primeng/table';
import { ChangeDetailComponent } from '../../change-detail/change-detail.component';
import { Table } from 'primeng/table';

@Component({
  selector: 'app-new-rulebooks',
  templateUrl: './new-rulebooks.component.html',
  styleUrls: ['./new-rulebooks.component.scss']
})

export class NewRulebooksComponent implements OnInit {

  @Input() libraryTabs: any;
  libraryName = '';
  rulebookName = '';
  @ViewChild(CdkVirtualScrollViewport)
  viewport!: CdkVirtualScrollViewport;
  @ViewChild('tableContent', { read: ElementRef })
  public tableContent: any;
  myInnerHeight: any;

  user: UserProfile;
  rulebookEndIndex = 0;
  deletedRowId = 0;
  isLoadingRulebook = false;
  ruleTopicsForToolTip = '';
  ruleBooks: RulebookViewModel;
  allRulebooks: Array<RulebookModel>;
  rulebookFilter: RulebookFilterModel;
  filterPersistenceKey = 'rulebookFilters';
  selectedRow = 0;
  toastModel: ToastViewModel;
  isToastShow = false;
  currenUrl: string;
  selectedRulebooks: Array<RulebookModel>;
  newRulebooksId: number;
  selectedItemId: number;
  selectedRulebookIds: Array<number>;
  alertDialogModel: AlertDialogModel;
  disableRuleId = 0;
  currentUserRole = '';
  separatorKeysCodes: number[] = [ENTER, COMMA];
  selectable = true;
  removable = true;
  addOnBlur = true;
  collapsedIds: Array<number>;
  itemActiveModel: Array<ItemActiveModel>;
  rulebookColumns: RulebookColumnModel;
  isRulebookRead = -1;
  isRulebookOperative = -1;
  tableWidth = 2240;

  // For Rule Id Filters
  selectedRuleIdFilters: string[] = [];
  @ViewChild('ruleIdAutocomplete')
  ruleIdAutocomplete!: MatAutocomplete;
  @ViewChild('ruleIdInput')
  ruleIdInput!: ElementRef<HTMLInputElement>;
  ruleIdCntrl: FormControl = new FormControl();
  searchedRuleId: string[] = [];

  // For Title1 Filters
  selectedTitle1Filters: string[] = [];
  @ViewChild('title1Autocomplete')
  title1Autocomplete!: MatAutocomplete;
  @ViewChild('title1Input')
  title1Input!: ElementRef<HTMLInputElement>;
  title1Cntrl: FormControl = new FormControl();
  searchedTitle1: string[] = [];

  // For Title2 Filters
  selectedTitle2Filters: string[] = [];
  @ViewChild('title2Autocomplete')
  title2Autocomplete!: MatAutocomplete;
  @ViewChild('title2Input')
  title2Input!: ElementRef<HTMLInputElement>;
  title2Cntrl: FormControl = new FormControl();
  searchedTitle2: string[] = [];

  // For Title3 Filters
  selectedTitle3Filters: string[] = [];
  @ViewChild('title3Autocomplete')
  title3Autocomplete!: MatAutocomplete;
  @ViewChild('title3Input')
  title3Input!: ElementRef<HTMLInputElement>;
  title3Cntrl: FormControl = new FormControl();
  searchedTitle3: string[] = [];

  // For Title1 Filters
  selectedTitle4Filters: string[] = [];
  @ViewChild('title4Autocomplete')
  title4Autocomplete!: MatAutocomplete;
  @ViewChild('title4Input')
  title4Input!: ElementRef<HTMLInputElement>;
  title4Cntrl: FormControl = new FormControl();
  searchedTitle4: string[] = [];

  // For Title5 Filters
  selectedTitle5Filters: string[] = [];
  @ViewChild('title5Autocomplete')
  title5Autocomplete!: MatAutocomplete;
  @ViewChild('title5Input')
  title5Input!: ElementRef<HTMLInputElement>;
  title5Cntrl: FormControl = new FormControl();
  searchedTitle5: string[] = [];
  //expandedRows: {} = {};
  expandedRows: { [key: number]: any } = {};
  hideExpantionTd = false;
  totalActiveColumn = 0;
  // @ViewChild(Table)
  // table!: Table;
  @ViewChild('myTable')
  myTable!: Table;
  @ViewChild('dt', { read: Table })
  table!: Table;
  firstRow: number = 0;
  totalRow: number = 0;
  expandedRowWitdth = 0;
  screeWidth = 0;
  pTableRows = 20;
  expandedRows1: any[] = [];
  rowHeight = 50; // You can change this value based on your needs

  //For New Template in Self Assessment
  divisionId: number;
  constructor(
    private gdprService: GDPRService,
    private route: ActivatedRoute,
    private sessionService: SessionService,
    public commonService: CommonService,
    private dialog: MatDialog,
    private router: Router,
    private eleRef: ElementRef,
    private routeReuseStrategy: RouteReuseStrategy,
    private cd: ChangeDetectorRef
  ) {
    //this.totalRow = this.pTableRows;
    this.myInnerHeight = window.innerHeight - 250;
    this.ruleBooks = new RulebookViewModel();
    this.allRulebooks = [];
    this.rulebookFilter = new RulebookFilterModel();
    this.rulebookFilter.SortKey = "Id"
    this.rulebookFilter.IsDesc = false;
    this.user = new UserProfile();
    this.toastModel = new ToastViewModel();
    this.currenUrl = this.router.url;
    this.selectedRulebooks = [];
    this.newRulebooksId = -1;
    this.selectedItemId = -1;
    this.selectedRulebookIds = [];
    this.sessionService.isLibraryTabActive = false;
    this.alertDialogModel = new AlertDialogModel();
    this.collapsedIds = [];
    this.itemActiveModel = [{ itemTitle: 'Regulator', itemWidth: 102, isActive: true }, { itemTitle: 'Title', itemWidth: 110, isActive: true },
    { itemTitle: 'Effective Date', itemWidth: 110, isActive: true }, { itemTitle: 'Version', itemWidth: 90, isActive: true },
    { itemTitle: 'Applicable', itemWidth: 110, isActive: true }, { itemTitle: 'Read', itemWidth: 102, isActive: true },
    { itemTitle: 'Operative', itemWidth: 102, isActive: true },
    { itemTitle: 'Part', itemWidth: 180, isActive: true },
    // { itemTitle: 'Title1', itemWidth: 180, isActive: false }, { itemTitle: 'Title2', itemWidth: 224, isActive: false },
    // { itemTitle: 'Title3', itemWidth: 224, isActive: false }, { itemTitle: 'Title4', itemWidth: 224, isActive: false },
    // { itemTitle: 'Title5', itemWidth: 224, isActive: false },
    { itemTitle: 'Rule Id', itemWidth: 110, isActive: false },
    { itemTitle: 'Owner', itemWidth: 110, isActive: true }
    ];
    this.rulebookColumns = new RulebookColumnModel();
    this.divisionId = JSON.parse(this.fetchFromBrowser("selectedDivision") as string);
  }

  ngOnInit(): void {
    this.fetchUserProfile();
    const persistFilter = JSON.parse(this.fetchFromBrowser(
      this.filterPersistenceKey
    ) as string) as RulebookFilterModel;
    if (persistFilter) {
      this.rulebookFilter = persistFilter;
    }
    this.sessionService.rulebookUrl = this.router.url;
    this.rulebookFilter.libraryName = this.route.snapshot.params.rulebook ? this.route.snapshot.params.rulebook : '';
    if (this.rulebookFilter.libraryName && this.route.snapshot.params.rulebookName) {
      this.rulebookFilter.rulebookName = this.route.snapshot.params.rulebookName ? this.route.snapshot.params.rulebookName : '';
      this.rulebookFilter.rulebookName = this.replaceAll(this.rulebookFilter.rulebookName);
    }
    else if (this.rulebookFilter.libraryName) {
      this.rulebookFilter.rulebookName = '';
      this.rulebookFilter.rulebookName = this.replaceAll(this.rulebookFilter.rulebookName);
    }
    this.rulebookFilter.IsDesc = false;
    this.rulebookFilter.SortKey = 'Id'
    this.getDateRange();
    const persistColumn = JSON.parse(this.fetchFromBrowser('_racol') as string) as ItemActiveModel[];
    if (persistColumn) {
      this.itemActiveModel = persistColumn;
    }
    this.eleRef.nativeElement.style.setProperty('--table-min-width', '2240px');
    this.itemActiveModel.forEach(element => {
      this.showHideColumn(element.itemTitle, element.itemWidth, element.isActive, 'OnLoad');
    });
    // this.router.routeReuseStrategy.shouldReuseRoute = function () {
    //   return false;
    // };
   

  }

  ngAfterViewInit() {
    const element = this.eleRef.nativeElement;
    this.screeWidth = element.offsetWidth;
    this.expandedRowWitdth = (this.screeWidth * 75) / 100;
    const tableEl = this.myTable.el.nativeElement;

   
   
  }
  


 

  fetchUserProfile(): void {
    this.sessionService.getLoginUserInfo().subscribe((user: UserProfile) => {
      this.user = user;
      if (this.user && this.user.roleId > 0) {
        this.fetchCurrentUserRole();
      }
    });
  }

  showHideColumn(item: string, itemWidth: number, isHide: boolean, filter: string): void {
    switch (item) {
      case 'Regulator':
        this.rulebookColumns.regulator = isHide;
        break;
      case 'Effective Date':
        this.rulebookColumns.effectiveDate = isHide;
        break;
      case 'Version':
        this.rulebookColumns.version = isHide;
        break;
      case 'Applicable':
        this.rulebookColumns.isApplicable = isHide;
        break;
      case 'Read':
        this.rulebookColumns.isRead = isHide;
        break;
      case 'Operative':
        this.rulebookColumns.isOperative = isHide;
        break;
      case 'Title':
        this.rulebookColumns.title = isHide;
        break;
      case 'Part':
        this.rulebookColumns.part = isHide;
        break;
      // case 'Title1':
      //   this.rulebookColumns.title1 = isHide;
      //   break;
      // case 'Title2':
      //   this.rulebookColumns.title2 = isHide;
      //   break;
      // case 'Title3':
      //   this.rulebookColumns.title3 = isHide;
      //   break;
      // case 'Title4':
      //   this.rulebookColumns.title4 = isHide;
      //   break;
      // case 'Title5':
      //   this.rulebookColumns.title5 = isHide;
      //   break;
      case 'Rule Id':
        this.rulebookColumns.ruleId = isHide;
        break;
      case 'Owner':
        this.rulebookColumns.owner = isHide;
        break;
    }
    if (filter === 'Change') {
      this.tableWidth = isHide ? this.tableWidth + itemWidth : this.tableWidth - itemWidth;
    } else if (!isHide) {
      this.tableWidth = isHide ? this.tableWidth + itemWidth : this.tableWidth - itemWidth;
    }
    this.eleRef.nativeElement.style.setProperty('--table-min-width', this.tableWidth + 'px');
    this.saveOnBrowser('_racol', JSON.stringify(this.itemActiveModel));
    this.totalActiveColumn = this.itemActiveModel.filter(ob => ob.isActive == true).length + 3;
  }

  replaceAll(str: string): string {
    if (str) {
      const strArr = str.split('_');
      if (strArr.length > 0) {
        strArr.forEach(element => {
          str = str.replace('_', ' ');
        });
      }
    }
    return str;
  }

  fetchCurrentUserRole(): void {
    this.gdprService.getCurrentUserRole(this.user.roleId).subscribe((data: Role) => {
      this.currentUserRole = data.title;
    });
  }

  public scrollRight(): void {
    this.tableContent.nativeElement.scrollTo({
      left: this.tableContent.nativeElement.scrollLeft + 150,
      behavior: 'smooth'
    });
  }

  public scrollLeft(): void {
    this.tableContent.nativeElement.scrollTo({
      left: this.tableContent.nativeElement.scrollLeft - 150,
      behavior: 'smooth'
    });
  }

  ruleBookHandler(): void {
    this.rulebookEndIndex = this.viewport.getRenderedRange().end;
  }

  getDateRange(): void {
    this.gdprService.getDateRange(this.rulebookFilter.libraryName, this.rulebookFilter.rulebookName).subscribe((data: DateRangeModel) => {
      if (data) {
        this.rulebookFilter.fromDate = data.fromDate;
        this.rulebookFilter.toDate = data.toDate;
      }
      this.saveOnBrowser(this.filterPersistenceKey, JSON.stringify(this.rulebookFilter));
      //this.getRulebooks();
    });
  }

  loadData(event?: LazyLoadEvent) {
    if (event && event?.rows) {
      this.totalRow = event.rows;
      this.totalRow = this.pTableRows;
    }
    else {
      this.firstRow = 0;
      this.ruleBooks.data = [];
    }
    if (this.isLoadingRulebook) {
      return;
    }
    else if (this.firstRow < this.ruleBooks.totalCount || this.firstRow === 0) {
      this.isLoadingRulebook = true;
      this.gdprService.getNewRulebooks(this.rulebookFilter, this.firstRow, (this.totalRow)).subscribe((data: RulebookViewModel) => {
        if (data) {
          Array.prototype.splice.apply(this.ruleBooks.data, [this.firstRow, this.totalRow, ...data.data]);
          // Array.prototype.splice.apply(this.ruleBooks.data, [...[this.firstRow, this.totalRow], ...data.data]);
          this.ruleBooks.totalCount = data.totalCount;
          this.allRulebooks = this.ruleBooks.data;
          this.sessionService.newRulebookCount = this.allRulebooks.filter(item => !item.isRead).length;
          this.getSearchedFilterData(this.ruleBooks.data);
        }
        this.selectedRulebookIds = [];
        this.rulebookEndIndex = this.rulebookEndIndex > this.ruleBooks.totalCount ? this.ruleBooks.totalCount : this.rulebookEndIndex;
        const thisRef = this;
        // this.ruleBooks.data.forEach(function (ob) {
        //   thisRef.expandedRows[ob.id] = true;
        // });
        

        this.expandedRows = Object.assign({}, this.expandedRows);
        this.ruleBooks.data = [...this.ruleBooks.data];
        this.ruleBooks.data.forEach((ob) => {
          this.expandedRows[ob.id] = true;
        });
        if (event != null && typeof event.forceUpdate === 'function') {
          event.forceUpdate();
        }
        // this.cd.markForCheck();
        this.cd.detectChanges();
        if (this.firstRow + this.totalRow > this.ruleBooks.totalCount) {
          this.firstRow = this.ruleBooks.totalCount;
        }
        else {
          this.firstRow = this.firstRow + this.totalRow;
        }
        this.isLoadingRulebook = false;
      }, (error: HttpErrorResponse) => {
        this.isLoadingRulebook = false;
        Logger.log(this.constructor.name, error.message);
      });
    }

  }
  onTableScroll(event: any) {
    const scrollableElement = event.target;
    const scrollHeight = scrollableElement.scrollHeight;
    const scrollTop = scrollableElement.scrollTop;
    const clientHeight = scrollableElement.clientHeight;

   
  }
  getRulebooks(): void {
    this.isLoadingRulebook = true;
    this.gdprService.getNewRulebooks(this.rulebookFilter, 0, this.totalRow).subscribe((data: RulebookViewModel) => {
      this.isLoadingRulebook = false;
      if (data) {
        this.ruleBooks = data;
        this.allRulebooks = this.ruleBooks.data;
        this.sessionService.newRulebookCount = this.allRulebooks.filter(item => !item.isRead).length;
        this.getSearchedFilterData(this.ruleBooks.data);
      }
      this.selectedRulebookIds = [];
      this.rulebookEndIndex = this.rulebookEndIndex > this.ruleBooks.totalCount ? this.ruleBooks.totalCount : this.rulebookEndIndex;
      const thisRef = this;
      this.ruleBooks.data.forEach(function (car) {
        thisRef.expandedRows[car.id] = true;
      });

      this.expandedRows = Object.assign({}, this.expandedRows);
    }, (error: HttpErrorResponse) => {
      this.isLoadingRulebook = false;
      Logger.log(this.constructor.name, error.message);
    });
  }

  sortRulebooks(key: string): void {
    this.rulebookFilter.IsDesc = !this.rulebookFilter.IsDesc;
    this.rulebookFilter.SortKey = key;
    // this.ruleBooks.data = this.rulebookFilter.IsDesc ? _.sortBy(this.ruleBooks.data, [key]).reverse()
    //   : _.sortBy(this.ruleBooks.data, [key]);
    this.loadData();
  }

  OnFilter(filter: RulebookFilterModel): void {
    this.rulebookFilter = filter;
    //this.getRulebooks();
    this.loadData();
  }

  saveOnBrowser(key: string, value: string): void {
    localStorage.setItem(key, value);
  }

  fetchFromBrowser(key: string): any {
    return localStorage.getItem(key);
  }

  selectRulebook(event: string, rulebookData: RulebookModel): void {
    if (event === 'Checked') {
      if (this.selectedRulebookIds.length < 20) {
        this.selectedRulebookIds.push(rulebookData.id);
        this.selectedRulebooks.push(rulebookData);
      } else {
        this.alertMessage('You can not select more than 20 items');
      }
    } else {
      const index2 = (this.selectedRulebooks as RulebookModel[]).indexOf(rulebookData);
      if (index2 >= 0) {
        (this.selectedRulebooks as RulebookModel[]).splice(index2, 1);
      }
      const index3 = (this.selectedRulebookIds as number[]).indexOf(rulebookData.id);
      if (index3 >= 0) {
        (this.selectedRulebookIds as number[]).splice(index3, 1);
      }
      this.isSelectedItem(rulebookData.id);
    }
  }

  insertNewRule(): void {
    if (this.selectedRulebooks.length === 1) {
      const dialogRef = this.dialog.open(ModalDialogComponent, {
        data: {
          width: '450px',
          message: 'New rule will be added to rulebook.',
          title: 'Insert new rule',
          btnText: 'OK',
        }
      });
      dialogRef.afterClosed().subscribe((data) => {
        if (data) {
          this.saveRulebook();
        }
      });
    } else if (this.selectedRulebooks.length > 1) {
      this.alertMessage('Multiple rows selected. Please select a single row');
    } else {
      this.alertMessage('Please select at least one rule');
    }
  }

  saveRulebook(): void {
    this.isLoadingRulebook = true;
    const itemInfoDto = new ItemInfoDto();
    itemInfoDto.rulebookInfo = this.selectedRulebooks[0];
    itemInfoDto.screenUrl = this.currenUrl;
    this.gdprService.saveRulebook(itemInfoDto).subscribe((data: any) => {
      this.selectedRulebookIds = [];
      this.selectedRulebooks = [];
      this.newRulebooksId = data.result;
      this.rulebookFilter.SortKey = 'Id';
      this.rulebookFilter.IsDesc = false;
      //this.getRulebooks();
      this.loadData();
    });
  }

  editRow(rulebook: RulebookModel): void {
    this.openEditDialog(rulebook);
  }

  openEditDialog(rulebook: RulebookModel): void {
    const dialogRef = this.dialog.open(RulebookDialogComponent, {
      width: '950px',
      data: rulebook
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.updateAllRulebooks(result);
      }
    });
  }

  updateAllRulebooks(rulebook: RulebookModel): void {
    this.isLoadingRulebook = true;
    rulebook.effectiveDate = MasterHelper.bsdatePickerToCorrectDate(rulebook.effectiveDate.toString());
    const itemInfoDto = new ItemInfoDto();
    itemInfoDto.rulebookInfo = rulebook;
    itemInfoDto.screenUrl = this.currenUrl;

    this.gdprService.updateRulebook(itemInfoDto).subscribe(() => {
      this.toastModel.Title = 'Success';
      this.toastModel.Type = 'success';
      this.toastModel.Message = 'Successfully Updated';
      this.isToastShow = true;
      setTimeout(() => {
        this.isToastShow = false;
      }, 5000);
      //this.getRulebooks();
      this.loadData();
    });
  }

  insertedRow(rulebook: RulebookModel): void {
    this.newRulebooksId = -1;
    this.isLoadingRulebook = true;
    const itemInfoDto = new ItemInfoDto();
    itemInfoDto.rulebookInfo = rulebook;
    itemInfoDto.screenUrl = this.currenUrl;
    this.gdprService.saveChildRow(itemInfoDto).subscribe((data: any) => {
      if (data.result > 0) {
        this.newRulebooksId = data.result;
        this.toastModel.Title = 'Success';
        this.toastModel.Type = 'success';
        this.toastModel.Message = 'Successfully Inserted';
        this.isToastShow = true;
        setTimeout(() => {
          this.isToastShow = false;
        }, 3000);
        //this.getRulebooks();
        this.loadData();
      } else {
        this.alertMessage('System does not allow for more than 100 rows to be inserted between two Rule Rows');
      }
    });
  }
  openDeleteModel(id: number): void {
    this.deletedRowId = id;
    const dialogRef = this.dialog.open(ModalDialogComponent, {
      data: {
        message: 'Are you sure want to delete?',
        title: 'Delete Row',
        btnText: 'Delete',
      }
    });
    dialogRef.afterClosed().subscribe((data) => {
      if (data) {
        this.deleteRow();
      }
    });
  }

  deleteRow(): void {
    if (this.deletedRowId > 0) {
      this.isLoadingRulebook = true;
      const itemInfoDto = new ItemInfoDto();
      itemInfoDto.id = this.deletedRowId;
      itemInfoDto.screenUrl = this.currenUrl;
      this.gdprService.removeRulebook(itemInfoDto).subscribe(() => {
        this.deletedRowId = 0;
        this.toastModel.Title = 'Success';
        this.toastModel.Type = 'success';
        this.toastModel.Message = 'Successfully Deleted';
        this.isToastShow = true;
        setTimeout(() => {
          this.isToastShow = false;
        }, 5000);
        //this.getRulebooks();
        this.loadData();
      });
    }
  }

  startSelfAssessmentRules(): void {
    this.selectedRow = 0;
    this.divisionId = JSON.parse(this.fetchFromBrowser("selectedDivision") as string);
    if (this.selectedRulebooks.length > 0) {
      if (this.selectedRulebooks.length > 1) {
        this.alertMessage('Multiple rows selected. Please select a single row');
      } else {
        this.isLoadingRulebook = true;
        const itemInfoDto = new ItemInfoDto();
        itemInfoDto.rulebookList = this.selectedRulebooks;
        itemInfoDto.id = this.deletedRowId;
        itemInfoDto.screenUrl = this.currenUrl;
        itemInfoDto.itemType = 'StartSelfAssessment';
        this.gdprService.addSelfAssessment(itemInfoDto,this.divisionId).subscribe((data: any) => {
          this.assessmentAlertMessage(data);
          this.isLoadingRulebook = false;
        });
      }
    } else {
      this.alertMessage('Please select at least one rule');
    }
  }

  mergeAndStartSelfAssessmentRules(): void {
    this.divisionId = JSON.parse(this.fetchFromBrowser("selectedDivision") as string);
    if (this.selectedRulebooks.length > 0) {
      const itemInfoDto = new ItemInfoDto();
      itemInfoDto.rulebookList = this.selectedRulebooks;
      itemInfoDto.id = this.deletedRowId;
      itemInfoDto.screenUrl = this.currenUrl;
      itemInfoDto.itemType = 'MergeAndStartSelfAssessment';
      this.isLoadingRulebook = true;
      this.gdprService.addSelfAssessment(itemInfoDto,this.divisionId).subscribe((data: any) => {
        this.assessmentAlertMessage(data);
        this.isLoadingRulebook = false;
      });
    } else {
      this.alertMessage('Please select at least one rule');
    }
  }

  alertMessage(warningText: string): void {
    this.toastModel.Title = 'Warning';
    this.toastModel.Type = 'warning';
    this.toastModel.Message = warningText;
    this.isToastShow = true;
    setTimeout(() => {
      this.isToastShow = false;
    }, 5000);
  }

  assessmentAlertMessage(data: any): void {
    if (data.result > 0) {
      this.toastModel.Title = 'Success';
      this.toastModel.Type = 'success';
      this.toastModel.Message = 'Rule Moved to Self Assessment';
    } else {
      this.toastModel.Title = 'Warning';
      this.toastModel.Type = 'warning';
      this.toastModel.Message = 'Rule not Moved to Self Assessment';
    }
    this.isToastShow = true;
    this.selectedRulebooks = [];
    setTimeout(() => {
      this.isToastShow = false;
      window.location.href = '/self-assessment/summary';
      this.saveOnBrowser('_said', data.result);
    }, 3500);
  }

  isSelectedItem(id: number): boolean {
    const index = (this.selectedRulebookIds as number[]).indexOf(id);
    return index >= 0 ? true : false;
  }

  enableRule(id: number, type: string): void {
    this.gdprService.disableRulebook(id, type).subscribe(() => {
    });
  }

  openDeleteDialog(id: number, type: string): void {
    this.disableRuleId = id;
    this.alertDialogModel.HeadingText = type;
    this.alertDialogModel.BodyText = 'Are you sure you want to remove this rule as ' + (type === 'Applicable' ? 'applicable?' : type === 'Read' ? 'read?' : 'operative?');
    this.alertDialogModel.ActionButtonText = 'Remove';
    this.alertDialogModel.IsAction = true;

    const dialogRef = this.dialog.open(DeleteDialogComponent, {
      width: '450px',
      data: this.alertDialogModel
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result === 'Applicable' || result === 'Read' || result === 'Operative') {
        this.disableRule(result);
      }
    });
  }

  disableRule(type: string): void {
    this.gdprService.disableRulebook(this.disableRuleId, type).subscribe(() => {
      this.disableRuleId = 0;
      //this.getRulebooks();
      this.loadData();
    });
  }

  checkMaxVersion(version: number, parentId: number, id: number): boolean {
    const index = (parentId && parentId > 0) ? this.ruleBooks.data.findIndex(a => a.version > version && a.parentId === parentId) :
      this.ruleBooks.data.findIndex(a => a.version > version && a.parentId === id);
    return index >= 0 ? true : false;
  }

  // For Title1 filter
  addTitle1(event: MatChipInputEvent): void {
    if (this.title1Autocomplete && !this.title1Autocomplete.isOpen) {
      const input = event.input;
      const value = event.value;
      if ((value || '').trim()) {
        (this.selectedTitle1Filters).push(value);
      }
      // Reset the input value
      if (input) {
        input.value = '';
      }
      this.title1Cntrl.setValue(null);
      this.title1Cntrl.disable();
      this.title1Cntrl.enable();
      this.getFilteredRulebooks();
    }
  }

  selectTitle1(event: MatAutocompleteSelectedEvent): void {
    if (this.selectedTitle1Filters) {
      this.selectedTitle1Filters.push(event.option.viewValue);
    } else {
      this.selectedTitle1Filters = [];
      this.selectedTitle1Filters.push(event.option.viewValue);
    }
    this.title1Input.nativeElement.value = '';
    this.title1Cntrl.setValue(null);
    this.title1Cntrl.disable();
    this.title1Cntrl.enable();
    this.getFilteredRulebooks();
  }

  removeTitle1(type: string): void {
    const index = (this.selectedTitle1Filters).indexOf(type);
    if (index >= 0) {
      (this.selectedTitle1Filters).splice(index, 1);
    }
    if (this.selectedTitle1Filters.length === 0) {
      this.ruleBooks.data = this.allRulebooks;
    }
    this.getFilteredRulebooks();
  }

  // For Title2 filter
  addTitle2(event: MatChipInputEvent): void {
    if (this.title2Autocomplete && !this.title2Autocomplete.isOpen) {
      const input = event.input;
      const value = event.value;
      if ((value || '').trim()) {
        (this.selectedTitle2Filters).push(value);
      }
      // Reset the input value
      if (input) {
        input.value = '';
      }
      this.title2Cntrl.setValue(null);
      this.title2Cntrl.disable();
      this.title2Cntrl.enable();
      this.getFilteredRulebooks();
    }
  }

  selectTitle2(event: MatAutocompleteSelectedEvent): void {
    if (this.selectedTitle2Filters) {
      this.selectedTitle2Filters.push(event.option.viewValue);
    } else {
      this.selectedTitle2Filters = [];
      this.selectedTitle2Filters.push(event.option.viewValue);
    }
    this.title2Input.nativeElement.value = '';
    this.title2Cntrl.setValue(null);
    this.title2Cntrl.disable();
    this.title2Cntrl.enable();
    this.getFilteredRulebooks();
  }

  removeTitle2(type: string): void {
    const index = (this.selectedTitle2Filters).indexOf(type);
    if (index >= 0) {
      (this.selectedTitle2Filters).splice(index, 1);
    }
    if (this.selectedTitle2Filters.length === 0) {
      this.ruleBooks.data = this.allRulebooks;
    }
    this.getFilteredRulebooks();
  }

  // For Title3 filter
  addTitle3(event: MatChipInputEvent): void {
    if (this.title3Autocomplete && !this.title3Autocomplete.isOpen) {
      const input = event.input;
      const value = event.value;
      if ((value || '').trim()) {
        (this.selectedTitle3Filters).push(value);
      }
      // Reset the input value
      if (input) {
        input.value = '';
      }
      this.title3Cntrl.setValue(null);
      this.title3Cntrl.disable();
      this.title3Cntrl.enable();
      this.getFilteredRulebooks();
    }
  }

  selectTitle3(event: MatAutocompleteSelectedEvent): void {
    if (this.selectedTitle3Filters) {
      this.selectedTitle3Filters.push(event.option.viewValue);
    } else {
      this.selectedTitle3Filters = [];
      this.selectedTitle3Filters.push(event.option.viewValue);
    }
    this.title3Input.nativeElement.value = '';
    this.title3Cntrl.setValue(null);
    this.title3Cntrl.disable();
    this.title3Cntrl.enable();
    this.getFilteredRulebooks();
  }

  removeTitle3(type: string): void {
    const index = (this.selectedTitle3Filters).indexOf(type);
    if (index >= 0) {
      (this.selectedTitle3Filters).splice(index, 1);
    }
    if (this.selectedTitle3Filters.length === 0) {
      this.ruleBooks.data = this.allRulebooks;
    }
    this.getFilteredRulebooks();
  }

  // For Title4 filter
  addTitle4(event: MatChipInputEvent): void {
    if (this.title4Autocomplete && !this.title4Autocomplete.isOpen) {
      const input = event.input;
      const value = event.value;
      if ((value || '').trim()) {
        (this.selectedTitle4Filters).push(value);
      }
      // Reset the input value
      if (input) {
        input.value = '';
      }
      this.title4Cntrl.setValue(null);
      this.title4Cntrl.disable();
      this.title4Cntrl.enable();
      this.getFilteredRulebooks();
    }
  }

  selectTitle4(event: MatAutocompleteSelectedEvent): void {
    if (this.selectedTitle4Filters) {
      this.selectedTitle4Filters.push(event.option.viewValue);
    } else {
      this.selectedTitle4Filters = [];
      this.selectedTitle4Filters.push(event.option.viewValue);
    }
    this.title4Input.nativeElement.value = '';
    this.title4Cntrl.setValue(null);
    this.title4Cntrl.disable();
    this.title4Cntrl.enable();
    this.getFilteredRulebooks();
  }

  removeTitle4(type: string): void {
    const index = (this.selectedTitle4Filters).indexOf(type);
    if (index >= 0) {
      (this.selectedTitle4Filters).splice(index, 1);
    }
    if (this.selectedTitle4Filters.length === 0) {
      this.ruleBooks.data = this.allRulebooks;
    }
    this.getFilteredRulebooks();
  }

  // For Title5 filter
  addTitle5(event: MatChipInputEvent): void {
    if (this.title5Autocomplete && !this.title5Autocomplete.isOpen) {
      const input = event.input;
      const value = event.value;
      if ((value || '').trim()) {
        (this.selectedTitle5Filters).push(value);
      }
      // Reset the input value
      if (input) {
        input.value = '';
      }
      this.title5Cntrl.setValue(null);
      this.title5Cntrl.disable();
      this.title5Cntrl.enable();
      this.getFilteredRulebooks();
    }
  }

  selectTitle5(event: MatAutocompleteSelectedEvent): void {
    if (this.selectedTitle5Filters) {
      this.selectedTitle5Filters.push(event.option.viewValue);
    } else {
      this.selectedTitle5Filters = [];
      this.selectedTitle5Filters.push(event.option.viewValue);
    }
    this.title5Input.nativeElement.value = '';
    this.title5Cntrl.setValue(null);
    this.title5Cntrl.disable();
    this.title5Cntrl.enable();
    this.getFilteredRulebooks();
  }

  removeTitle5(type: string): void {
    const index = (this.selectedTitle5Filters).indexOf(type);
    if (index >= 0) {
      (this.selectedTitle5Filters).splice(index, 1);
    }
    if (this.selectedTitle5Filters.length === 0) {
      this.ruleBooks.data = this.allRulebooks;
    }
    this.getFilteredRulebooks();
  }

  // For RuleId filter
  addRuleId(event: MatChipInputEvent): void {
    if (this.ruleIdAutocomplete && !this.ruleIdAutocomplete.isOpen) {
      const input = event.input;
      const value = event.value;
      if ((value || '').trim()) {
        (this.selectedRuleIdFilters).push(value);
      }
      // Reset the input value
      if (input) {
        input.value = '';
      }
      this.ruleIdCntrl.setValue(null);
      this.ruleIdCntrl.disable();
      this.ruleIdCntrl.enable();
      this.getFilteredRulebooks();
    }
  }

  selectRuleId(event: MatAutocompleteSelectedEvent): void {
    if (this.selectedRuleIdFilters) {
      this.selectedRuleIdFilters.push(event.option.viewValue);
    } else {
      this.selectedRuleIdFilters = [];
      this.selectedRuleIdFilters.push(event.option.viewValue);
    }
    this.ruleIdInput.nativeElement.value = '';
    this.ruleIdCntrl.setValue(null);
    this.ruleIdCntrl.disable();
    this.ruleIdCntrl.enable();
    this.getFilteredRulebooks();
  }

  removeRuleId(type: string): void {
    const index = (this.selectedRuleIdFilters).indexOf(type);
    if (index >= 0) {
      (this.selectedRuleIdFilters).splice(index, 1);
    }
    if (this.selectedRuleIdFilters.length === 0) {
      this.ruleBooks.data = this.allRulebooks;
    }
    this.getFilteredRulebooks();
  }

  getFilteredRulebooks(): void {
    if ((this.selectedRuleIdFilters.length === 0 && this.selectedTitle1Filters.length === 0)
      || this.ruleBooks.data.length === 0) {
      this.ruleBooks.data = this.allRulebooks;
    }
    this.ruleBooks.totalCount = this.ruleBooks.data.length;
    if (this.selectedRuleIdFilters.length > 0) {
      const searchedResult = Array<RulebookModel>();
      this.ruleBooks.data.forEach(element => {
        this.selectedRuleIdFilters.forEach(element2 => {
          if (element.ruleId && element.ruleId.toUpperCase().includes(element2.toUpperCase())) {
            searchedResult.push(element);
          }
        });
      });
      this.ruleBooks.data = searchedResult;
    }
    if (this.selectedTitle1Filters.length > 0) {
      const searchedResult = Array<RulebookModel>();
      this.ruleBooks.data.forEach(element => {
        this.selectedTitle1Filters.forEach(element2 => {
          if (element.title1 && element.title1.toUpperCase().includes(element2.toUpperCase())) {
            searchedResult.push(element);
          }
        });
      });
      this.ruleBooks.data = searchedResult;
    }
    if (this.selectedTitle2Filters.length > 0) {
      const searchedResult = Array<RulebookModel>();
      this.ruleBooks.data.forEach(element => {
        this.selectedTitle2Filters.forEach(element2 => {
          if (element.title2 && element.title2.toUpperCase().includes(element2.toUpperCase())) {
            searchedResult.push(element);
          }
        });
      });
      this.ruleBooks.data = searchedResult;
    }
    if (this.selectedTitle3Filters.length > 0) {
      const searchedResult = Array<RulebookModel>();
      this.ruleBooks.data.forEach(element => {
        this.selectedTitle3Filters.forEach(element2 => {
          if (element.title3 && element.title3.toUpperCase().includes(element2.toUpperCase())) {
            searchedResult.push(element);
          }
        });
      });
      this.ruleBooks.data = searchedResult;
    }
    if (this.selectedTitle4Filters.length > 0) {
      const searchedResult = Array<RulebookModel>();
      this.ruleBooks.data.forEach(element => {
        this.selectedTitle4Filters.forEach(element2 => {
          if (element.title4 && element.title4.toUpperCase().includes(element2.toUpperCase())) {
            searchedResult.push(element);
          }
        });
      });
      this.ruleBooks.data = searchedResult;
    }
    if (this.selectedTitle5Filters.length > 0) {
      const searchedResult = Array<RulebookModel>();
      this.ruleBooks.data.forEach(element => {
        this.selectedTitle5Filters.forEach(element2 => {
          if (element.title5 && element.title5.toUpperCase().includes(element2.toUpperCase())) {
            searchedResult.push(element);
          }
        });
      });
      this.ruleBooks.data = searchedResult;
    }
    if (+this.isRulebookRead > -1) {
      const isRead = +this.isRulebookRead === 1 ? true : false;
      this.ruleBooks.data = this.ruleBooks.data.filter(a => a.isRead === isRead);
    }
    if (+this.isRulebookOperative > -1) {
      const isOp = +this.isRulebookOperative === 1 ? true : false;
      this.ruleBooks.data = this.ruleBooks.data.filter(a => a.operative === isOp);
    }
    this.getSearchedFilterData(this.ruleBooks.data);
    this.ruleBooks.totalCount = this.ruleBooks.data.length;
    this.rulebookEndIndex = this.rulebookEndIndex > this.ruleBooks.totalCount ? this.ruleBooks.totalCount : this.rulebookEndIndex;
  }

  getSearchedFilterData(rulebookData: RulebookModel[]): void {
    this.searchedRuleId = [];
    this.searchedTitle1 = [];
    this.searchedTitle2 = [];
    this.searchedTitle3 = [];
    this.searchedTitle4 = [];
    this.searchedTitle5 = [];
    rulebookData.forEach(element => {
      if (element.ruleId) {
        const index = (this.searchedRuleId as string[]).indexOf(element.ruleId);
        if (index < 0) {
          this.searchedRuleId.push(element.ruleId);
        }
      }
      if (element.title1) {
        const index = (this.searchedTitle1 as string[]).indexOf(element.title1);
        if (index < 0) {
          this.searchedTitle1.push(element.title1);
        }
      }
      if (element.title2) {
        const index = (this.searchedTitle2 as string[]).indexOf(element.title2);
        if (index < 0) {
          this.searchedTitle2.push(element.title2);
        }
      }
      if (element.title3) {
        const index = (this.searchedTitle3 as string[]).indexOf(element.title3);
        if (index < 0) {
          this.searchedTitle3.push(element.title3);
        }
      }
      if (element.title4) {
        const index = (this.searchedTitle4 as string[]).indexOf(element.title4);
        if (index < 0) {
          this.searchedTitle4.push(element.title4);
        }
      }
      if (element.title5) {
        const index = (this.searchedTitle5 as string[]).indexOf(element.title5);
        if (index < 0) {
          this.searchedTitle5.push(element.title5);
        }
      }
    });
    this.searchedRuleId.sort();
    this.searchedTitle1.sort();
    this.searchedTitle2.sort();
    this.searchedTitle3.sort();
    this.searchedTitle4.sort();
    this.searchedTitle5.sort();
  }

  bulkRuleAnalytics(): void {
    if (this.selectedRulebookIds.length === 0) {
      this.alertMessage('Please select at least one rule');
    }
    else {
      const bulkRuleData = new BulkRulebookData();
      bulkRuleData.rulebookIds = this.selectedRulebookIds.sort();
      bulkRuleData.rulebooks = _.sortBy(this.selectedRulebooks, 'id');
      const dialogRef = this.dialog.open(BulkRuleAnalyticComponent, {
        width: '1800px',
        data: bulkRuleData
      });
      dialogRef.afterClosed().subscribe(result => {
      });
    }
  }

  showHideData(id: number, filter: string): void {
    if (filter === 'Show') {
      this.collapsedIds.push(id);
    } else {
      const index = (this.collapsedIds as number[]).indexOf(id);
      if (index >= 0) {
        (this.collapsedIds as number[]).splice(index, 1);
      }
    }
  }

  checkCollapsed(id: number): boolean {
    const index = (this.collapsedIds as number[]).indexOf(id);
    return index >= 0 ? true : false;
  }

  showSpiderLinks(description: string, spLinks: string): string {
    if (description) {
      const descArr = description.split('\n');
      const strArr = new Array<string>();
      descArr.forEach(item => {
        if (item) {
          strArr.push('<p>' + item + '</p>');
        }
      });
      description = strArr.join(' ');
    }
    if (spLinks) {
      const spArr1 = spLinks.split('||');
      if (spArr1.length > 0) {
        spArr1.forEach(element => {
          if (element) {
            const spArr2 = element.split('|');
            description = description.split(spArr2[0]).join('<a href=' + spArr2[1] + ' target="_blank">' + spArr2[0] + '</a>');
          }
        });
        return description;
      }
    }
    return description;
  }

  removeSelectedItems(): void {
    this.selectedRulebookIds = [];
    this.selectedRulebooks = [];
  }

  sortArray(itemArray: string[]): string[] {
    let sortArray = MasterHelper.sortArray(itemArray, 'asc');
    return MasterHelper.getDistinctValues(sortArray);
  }
  sortAndDistinctArray(itemArray: string[]): string[] {
    let sortArray = MasterHelper.sortArray(itemArray, 'asc');
    return MasterHelper.getDistinctValues(sortArray);
  }
  openView(id: number, detailType: number) {
    const dialogRef = this.dialog.open(ChangeDetailComponent, {
      width: '1800px',
      height: '870px',
      data: { id: id, detailType: detailType },
    });
    dialogRef.afterClosed().subscribe((result) => {
      this.sessionService.isLibraryTabActive = false;
    });
  }

}

